
import React from 'react';
import SkillsAcquisitionGuide from '../SkillsAcquisitionGuide';

const SkillsAcquisitionTab: React.FC = () => {
  return (
    <div className="grid grid-cols-1 gap-6">
      <SkillsAcquisitionGuide />
    </div>
  );
};

export default SkillsAcquisitionTab;
